class AssetService {

    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope) {

        return {

            getAsset: (assetId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + "asset/" + assetId)
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            uploadFile: (folderId, file, cbStatus, cbProgress) => {
                var uploadURL ="/api/asset";
                var extraData ={}; //Extra Data.
                
                var fd = new FormData();
                fd.append("folderId", folderId);
                fd.append('file', file);
                
                var jqXHR = $.ajax({
                    xhr: () => {
                        var xhrobj = $.ajaxSettings.xhr();
                        if (xhrobj.upload) {
                            xhrobj.upload.addEventListener('progress', (event) => {
                                var percent = 0;
                                var position = event.loaded || event.position;
                                var total = event.total;
                                if (event.lengthComputable) {
                                    percent = Math.ceil(position / total * 100);
                                }
                                if(cbProgress) {
                                    cbProgress(percent);
                                }
                            }, false);
                        }
                        return xhrobj;
                    },
                    url: uploadURL,
                    type: "POST",
                    contentType: false,
                    processData: false,
                    cache: false,
                    data: fd,
                    success: (data) => {
                        if(cbProgress) {
                            cbProgress(100);
                        }
                        cbStatus(data);
                    },
                    error: (status) => {
                        console.error(status);               
                    }
                });
            },

            transcode: (assetId) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + "asset/" + assetId + "/transcode", null, {errorMessage: 'Failed to transcode asset.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            generateVideoThumbnail: (assetId) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + "asset/" + assetId + "/thumbnail/", null, {errorMessage: 'Failed to generate the video thumbnail.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            }


        };



    }

}

angular.module('cpm')
    .service('AssetService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', AssetService]);
